//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ManageConnections from './ManageConnections.vue';
import Confirmation from '../../../layout/Confirmation.vue';
import modalAware from '../../../common/mixins/modalAware';

export default {
  components: {
    ManageConnections,
    Confirmation,
  },

  mixins: [modalAware],

  data() {
    return {
      appleInstructions: false,
    };
  },

  computed: {
    enabled() {
      return this.$route.meta.enabled;
    },

    origin() {
      return `${this.$route.name}`;
    },
  },

  mounted() {
    if (!this.modalOpen && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  },
  watch: {
    modalOpen() {
      document.body.style.overflow = this.modalOpen ? 'hidden' : '';
    },
  },

  methods: {
    handleInstructions() {
      this.appleInstructions = !this.appleInstructions;
    },
  },
};
